import { ActionTypes } from "store/constants";

const init = [];

export const worksheetReducer = (state = init, action) => {
  switch (action.type) {
    case ActionTypes.worksheet.set_worksheet_list:
      return action.payload;
    case ActionTypes.worksheet.delete_question_by_id:
      return state.filter((item) => item.id !== action.payload);
    case ActionTypes.worksheet.update_worksheet_image_success:
      return state.map((k) => {
        const has_data = action.payload.find((i) => i.id == k.id);
        return has_data ? { ...k, ...has_data } : k;
      });
    case ActionTypes.worksheet.update_worksheet_list:
      return state.map(x => { if (x.id === action.payload?.id) { return { ...x, ...action.payload }; } return x; });
    default:
      return state;
  }
};

const initImage = [];

export const worksheetImageReducer = (state = initImage, action) => {
  switch (action.type) {
    case ActionTypes.worksheet.update_worksheet_image:
      return action.payload;
    default:
      return state;
  }
};